<template>
  <div>
    <PageHeader :title="title" :items="itemsPageHeader" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="p-3">
              <div class="row align-items-center">
                <div class="col">
                  <h6 class="m-0">
                    {{ $t('navbar.dropdown.notification.text') }}
                  </h6>
                </div>
              </div>
            </div>
            <simplebar ref="scroll" style="max-height: 650px;">
              <a
                v-for="item in notificationItems"
                :key="item._id"
                class="text-reset notification-item"
              >
                <div
                  v-if="hasItemPayload(item)"
                  class="media"
                  :style="`background-color:${bgColor(item.status)}`"
                >
                  <!-- <img
                  :id="
                          `popover-target-approve-member-person-${
                            item._id
                          }`
                        "
                    :src="item.payload.body_thumbnail_image_url"
                    class="mr-3 rounded-circle avatar-xs"
                    alt="user-pic"
                  /> -->
                  <userBadge
                    :user_photo="item.web_notification.content_obj.body_thumbnail_image_url"
                    :user_name="item.sender.sender_name.en"
                    :avatar_size="'30'"
                    :styleClass="`mr-3`"
                  />
                  <div class="media-body pointer" @click="read(item)">
                    <h6 class="mt-0 mb-1">{{ item.web_notification.title }}</h6>
                    <div class="font-size-12 text-muted">
                      <p class="mb-1">{{ item.web_notification.content_obj.body_text }}</p>
                      <p class="mb-0">
                        <i class="mdi mdi-clock-outline"></i>
                        {{ timeSince(item.timestamp) }}
                        จาก {{item.sender.sender_name.th}}
                      </p>
                    </div>
                  </div>
                  <div class="">
                    <a class="mr-3 pointer" v-if="item.status !== 'Read'" @click="markAsRead(item)">
                      <i class="mdi mdi-email-mark-as-unread"></i> Mark as read
                    </a>
                    <a class="pointer" @click="read(item, true)" >
                      <i class="bx bx-link-external"></i> Open new window
                    </a>
                  </div>
                  <b-popover
                      variant="info"
                      :target="`popover-target-approve-member-person-${
                                              item._id
                                            }`"
                      triggers="hover"
                      placement="top"
                    >
                      <template #title
                        >
                        {{ item.sender.sender_name.th }}
                      </template>
                  </b-popover>
                </div>
              </a>
              <template v-if="!isLoadComplete">
                <a
                  v-for="round in roundSkeletion"
                  :key="round"
                  class="text-reset notification-item"
                >
                  <div class="media">
                    <div class="mr-3 rounded-circle avatar-xs">
                      <vueSkeletonLoader
                        type="circle"
                        :width="32"
                        :height="32"
                        animation="wave"
                      />
                    </div>
                    <div class="media-body">
                      <h6 class="mt-0 mb-1">
                        <vueSkeletonLoader
                          type="rect"
                          :width="240"
                          :height="17"
                          rounded
                          animation="wave"
                        />
                      </h6>
                      <div class="font-size-12 text-muted">
                        <p class="mb-1">
                          <vueSkeletonLoader
                            type="rect"
                            :width="120"
                            :height="15"
                            rounded
                            animation="wave"
                          />
                        </p>
                        <p class="mb-0">
                          <vueSkeletonLoader
                            type="rect"
                            :width="36"
                            :height="15"
                            rounded
                            animation="wave"
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                </a>
              </template>
            </simplebar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import { eventBus } from '@/main.js'
import authorizeProvider from '@/helpers/service/authorize-provider'
import {
  NotificationEnum,
  NotificationTypeEnum,
} from '@/enum/notification.enum.js'
import vueSkeletonLoader from 'skeleton-loader-vue'
import userBadge from '@/components/share/user-badge'
import simplebar from 'simplebar-vue'

import { notificationMethods } from '@/state/helpers'

export default {
  name: 'brand',
  page: {
    title: 'Notification',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    PageHeader,
    simplebar,
    vueSkeletonLoader,
    userBadge,
  },
  data() {
    return {
      title: 'Notification',
      itemsPageHeader: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Notifications',
          active: true,
        },
      ],
      notification: {
        totalRecords: 0,
        totalPages: 0,
        pageNo: 1,
        pageSize: 20,
        hasPreviousPage: false,
        hasNextPage: false,
        items: [],
      },
      notificationItems:[]
      ,
      accountToken: '',
      isLoadComplete: true,
      roundSkeletion: 2,
    }
  },
  computed: {},
  mounted() {
    this.accessToken = this.$cookies.get('.oauth.at')
    this.getNotification()
    this.$refs.scroll.scrollElement.addEventListener(
      'scroll',
      this.handleScroll
    )
  },
  watch: {},
  methods: {
    ...notificationMethods,
    async getNotification() {
      let params = new URLSearchParams()
      params.append('page', this.notification.pageNo)
      params.append('pagesize', this.notification.pageSize)
      let result = await authorizeProvider.getNotification(
        this.accessToken,
        params
      )
      if (result.status === 200) {
        // console.log(result.data)
        this.notification.totalRecords = result.data.totalRecords
        this.notification.totalPages = result.data.totalPages
        this.notification.pageNo = result.data.pageNo
        this.notification.pageSize = result.data.pageSize
        this.notification.hasNextPage = result.data.hasNextPage

        let uniqueItems = result.data.items
        let ids = this.notificationItems.map(q => q._id)
        if (ids.length)
          uniqueItems = result.data.items.filter(q => !ids.includes(q._id))

        uniqueItems.forEach(element => {
          element.web_notification.content_obj = JSON.parse(element.web_notification.content)
        });

        this.notificationItems.push(...uniqueItems)
        // console.log(this.notificationItems)
        this.titleTotalMessages()
        this.isLoadComplete = true
      } else {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    titleTotalMessages() {
      let unreadItems = this.notificationItems.filter(
        q => q.status === NotificationEnum.UNREAD
      )
      this.setTotalMessage(unreadItems.length)
    },
    hasItemPayload(item) {
      return item.web_notification !== undefined && item.web_notification !== null
    },
    handleScroll(event) {
      let { scrollTop, scrollHeight, clientHeight } = event.target
      const offsetForTrigger = 50
      if (
        scrollHeight - clientHeight - offsetForTrigger < scrollTop &&
        this.isLoadComplete &&
        this.notification.hasNextPage
      ) {
        this.isLoadComplete = false
        this.notification.pageNo++
        setTimeout(() => this.getNotification(), 1000)
      }
    },
    timeSince(dateObject) {
      var date = new Date(dateObject)
      var seconds = Math.floor((new Date() - date) / 1000)
      var interval = seconds / 31536000
      if (interval > 1) {
        return Math.floor(interval) + ' ปีที่แล้ว'
      }
      interval = seconds / 2592000
      if (interval > 1) {
        return Math.floor(interval) + ' เดือนที่แล้ว'
      }
      interval = seconds / 86400
      if (interval > 1) {
        return Math.floor(interval) + ' วันที่แล้ว'
      }
      interval = seconds / 3600
      if (interval > 1) {
        return Math.floor(interval) + ' ชั่วโมงที่แล้ว'
      }
      interval = seconds / 60
      if (interval > 1) {
        return Math.floor(interval) + ' นาทีที่แล้ว'
      }
      return Math.floor(seconds) + ' วินาทีที่แล้ว'
    },
    bgColor(status) {
      let color = 'white'
      switch (status) {
        case NotificationEnum.UNREAD:
          color = '#caf4f9'
          break
        case NotificationEnum.ACKNOWLEDGE:
          color = '#f3f3f3'
          break
        case NotificationEnum.READ:
          color = 'white'
          break
        default:
          color = 'white'
      }
      return color
    },
    async read(item, targetBlank) {
      await this.updateStatusNotification(item._id, NotificationEnum.READ)
      // console.log('read', item)
      if (
        item.web_notification !== undefined &&
        item.web_notification !== null &&
        item.web_notification.interact_methods.click.action_type === NotificationTypeEnum.ROUTEPATH
      ) {
        if (item.status !== NotificationEnum.READ)
          item.status = NotificationEnum.READ
        this.titleTotalMessages()
        if (targetBlank) {
          let routeData = this.$router.resolve({
            path: item.web_notification.interact_methods.click.action_value,
          })
          window.open(routeData.href, '_blank')
        } else {
          this.$router.push({ path: item.web_notification.interact_methods.click.action_value })
        }
      }
    },
    async updateStatusNotification(id, status) {
      let result = await authorizeProvider.updateStatusNotification(
        this.accessToken,
        id,
        status
      )
      // console.log('noti', result)
      if (result.status !== 204) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async markAsRead(item) {
      await this.updateStatusNotification(item._id, NotificationEnum.READ)
      item.status = NotificationEnum.READ
    },
  },
}
</script>
<style></style>
